export default __webpack_public_path__ + "static/media/juego_edocuenta_gana.24a4de2e.png";